import { FC } from "react";
import { CheckCircle } from "lucide-react";
import { Button } from "src/components/ui/button";

interface Props {
	observedUser: string;
	resetForm: () => void;
	onObserveAnotherUser?: () => void;
	onSelectAnotheForm?: () => void;
}

const SubmittedForm: FC<Partial<Props>> = ({
	observedUser,
	onObserveAnotherUser,
	onSelectAnotheForm
}) => {
	return (
		<div className="flex justify-center py-16">
			<div className="bg-white rounded-xl border border-border-light shadow-sm p-10 max-w-md w-full text-center">
				<div className="flex flex-col items-center gap-3 mb-8">
					<div className="h-14 w-14 rounded-full bg-green-50 flex items-center justify-center">
						<CheckCircle
							className="h-8 w-8 text-green-700"
							data-testid="check-circle-icon"
						/>
					</div>

					<h2 className="font-heading text-lg font-medium text-foreground">
						Submitted successfully
					</h2>
					<p className="text-sm text-muted-foreground">for {observedUser}</p>
				</div>

				<div className="flex flex-col gap-3">
					<Button
						type="button"
						className="w-full"
						onClick={onObserveAnotherUser}
					>
						Start a new observation
					</Button>

					<Button
						type="button"
						className="w-full"
						variant="outline"
						onClick={onSelectAnotheForm}
					>
						{window.ReactNativeWebView ? "Close" : "Select another form"}
					</Button>
				</div>
			</div>
		</div>
	);
};

export default SubmittedForm;
